import { Component, OnDestroy } from '@angular/core';
import { MatRadioModule } from '@angular/material/radio';
import { FormsModule } from '@angular/forms';
import { DataTableFilterMessageService } from '../../../../../../shared/components/data-table/filters/components/data-table-filter-message-service';
import { BaseDataTableFilter } from '../../../../../../shared/components/data-table/filters/components/data-table-filter/BaseDataTableFilter';
import { PoliciesFilterStateService } from '../../../../services/policies-filter-state.service';
import { PoliciesTableMessageService } from '../../../../services/policies-table-message.service';

@Component({
  selector: 'app-policies-filter-status',
  templateUrl: './policies-filter-status.component.html',
  styleUrls: ['./policies-filter-status.component.scss'],
  standalone: true,
  imports: [
    MatRadioModule,
    FormsModule
  ]
})
export class PoliciesFilterStatusComponent extends BaseDataTableFilter implements OnDestroy {

  constructor(
    private filterStateService: PoliciesFilterStateService,
    private filterMessageService: DataTableFilterMessageService,
    private policiesMessageService: PoliciesTableMessageService
  ) {
    super(filterMessageService);
  }

  ngOnDestroy(): void {
    this.filterStateService.reset();
    this.clearSubscriptions();
  }

  onApplyClicked(): void {    
    const isActive = this.filterStateService.status != 0;

    let statusText;
    if (this.filterStateService.status == 1) {
      statusText = "Active";
    }
    if (this.filterStateService.status == 2) {
      statusText = "Inactive";
    }

    this.policiesMessageService.applyFilter();
    this.filterMessageService.setActive({ filterId: this.id, active: isActive, value: statusText });
  }

  onClearClicked(): void {
    this.filterStateService.resetStatusFilter();
    this.policiesMessageService.applyFilter();
    this.filterMessageService.setActive({ filterId: this.id, active: false });
  }

  getStateService(): PoliciesFilterStateService {
    return this.filterStateService;
  }

  openedChange(opened: boolean) {
    const clickoutEnabled = !opened;
    this.filterMessageService.setClickoutEnabled(clickoutEnabled);
  }
}